import { useEffect } from 'react'

interface Props {
  value: number
  onChange: (n: number) => void
  storageKey?: string
  options?: number[]
}

const DEFAULT_OPTIONS = [10, 25, 50, 100]

export function PageSizeSelector({ value, onChange, storageKey, options = DEFAULT_OPTIONS }: Props) {
  useEffect(() => {
    if (!storageKey) return
    const saved = localStorage.getItem(storageKey)
    if (saved) {
      const parsed = parseInt(saved, 10)
      if (!isNaN(parsed) && options.includes(parsed) && parsed !== value) {
        onChange(parsed)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storageKey])

  const handleChange = (n: number) => {
    onChange(n)
    if (storageKey) localStorage.setItem(storageKey, String(n))
  }

  return (
    <label className="inline-flex items-center gap-2 text-xs text-content-muted">
      Mostrar
      <select
        value={value}
        onChange={e => handleChange(parseInt(e.target.value, 10))}
        className="bg-input-bg border border-input-border rounded-md px-2 py-1 text-xs text-content focus:outline-none focus:ring-2 focus:ring-primary"
      >
        {options.map(n => (
          <option key={n} value={n}>{n}</option>
        ))}
      </select>
      por página
    </label>
  )
}

export const DEFAULT_PAGE_SIZE = 25
